import React from 'react'
import { ToggleDescMobile } from './ToggleDescMobile'

import { ToogleDescription } from './ToogleDescription'

export function Content({ items }) {
    return (
        <>
            <div>
                <ToogleDescription itemsToggle={items} />
            </div>

            <div>
                <ToggleDescMobile itemsToggle={items} />
            </div>
        </>
    )
}
